export default __webpack_public_path__ + "static/media/aliahsonimg.06bbcd02.png";